import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { FaTimes, FaPlus, FaUserAlt } from "react-icons/fa";
import Geocode from "react-geocode";
import Popup from "reactjs-popup";
import cn from "classnames";

import { Page, Input } from "ui/components";
import { Shipment, Leg } from "services/action";
import { formatDate, UTCFormat } from "utilities/common";

import epod from "ui/assets/epod.png";
import SignatureSection from "./signature";
import CameraScreen from "./camera";
import ShipmentList from "./list";

const PODScreen = ({ location }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);

  const {
    type,
    manifest_id,
    leg_id,
    shipment_id,
    manifest_type,
    leg_type,
    is_receive,
    data,
  } = location?.state;

  const [img, setImage] = React.useState([]);
  const [pos, setPos] = React.useState(null);
  const [, setAddress] = React.useState(null);
  const [receiver, setReceiver] = React.useState("");
  const [note, setNote] = React.useState("");
  const [jobs, setJobs] = React.useState([]);

  const [sig, setSig] = React.useState(null);

  const [show, setShow] = React.useState(false);

  const $removeImg = async (i) => {
    let newImg = [...img];
    newImg.splice(i, 1);
    setImage(newImg);
  };

  const $onStart = async (e) => {
    let payload = {
      images: img,
      latitude: pos?.lat,
      longitude: pos?.lng,
    };

    if (type === "departure") {
      payload.images = img;
      payload.atd_at = UTCFormat(
        formatDate(new Date(), "YYYY-MM-DD"),
        formatDate(new Date(), "HH:mm")
      );

      const req = await Dispatch(Leg.$departure(manifest_id, leg_id, payload));

      if (req?.message === "success") {
        History.goBack();
      }
    }

    if (type === "arrival") {
      payload.images = img;
      payload.ata_at = UTCFormat(
        formatDate(new Date(), "YYYY-MM-DD"),
        formatDate(new Date(), "HH:mm")
      );

      const req = await Dispatch(Leg.$arrival(manifest_id, leg_id, payload));

      if (req?.message === "success") {
        History.goBack();
      }
    }

    if (type === "loading") {
      payload.images = img;
      payload.loading_at = UTCFormat(
        formatDate(new Date(), "YYYY-MM-DD"),
        formatDate(new Date(), "HH:mm")
      );

      payload.jobs = jobs;

      const req = await Dispatch(Leg.$loading(manifest_id, leg_id, payload));

      if (req?.message === "success") {
        History.go(-2);
      }
    }

    if (type === "delivered") {
      payload.received_by = receiver;
      payload.completed_note = note;

      let imgs = [];
      if (img?.length > 0) {
        const pay = {
          type: "delivered",
          urls: img,
        };
        imgs?.push(pay);

        if (sig) {
          const sgt = {
            type: "signature",
            urls: [sig?.image],
          };
          imgs?.push(sgt);
        }
      }

      if (imgs?.length > 0) {
        payload.images = imgs;
      }

      if (!is_receive && manifest_type === "last_mile") {
        payload.jobs = jobs;
      }

      const req = await Dispatch(Leg.$delivered(manifest_id, leg_id, payload));

      if (req?.message === "success") {
        History.go(-2);
      }
    }

    if (type === "disputed") {
      payload.disputed_note = note;
      payload.images = img;

      const req = await Dispatch(Leg.$disputed(manifest_id, leg_id, payload));

      if (req?.message === "success") {
        History.go(-2);
      }
    }

    if (type === "shipment-console") {
      payload.images = img;

      const req = await Dispatch(Shipment.$console(shipment_id, payload));

      if (req?.message === "success") {
        History.goBack();
      }
    }

    if (type === "shipment-delivered") {
      payload.received_by = receiver;
      payload.ata_at = UTCFormat(
        formatDate(new Date(), "YYYY-MM-DD"),
        formatDate(new Date(), "HH:mm")
      );

      let imgs = [];
      if (img?.length > 0) {
        const pyl = {
          type: "delivered",
          urls: img,
        };
        imgs?.push(pyl);

        if (sig) {
          const sgt = {
            type: "signature",
            urls: [sig?.image],
          };
          imgs?.push(sgt);
        }
      }

      if (imgs?.length > 0) {
        payload.images = imgs;
      }
      const req = await Dispatch(Shipment.$delivered(shipment_id, payload));

      if (req?.message === "success") {
        History.goBack();
      }
    }

    if (type === "shipment-disputed") {
      payload.disputed_note = note;
      payload.images = img;
      payload.ata_at = UTCFormat(
        formatDate(new Date(), "YYYY-MM-DD"),
        formatDate(new Date(), "HH:mm")
      );

      const req = await Dispatch(Shipment.$disputed(shipment_id, payload));

      if (req?.message === "success") {
        History.goBack();
      }
    }
  };

  React.useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setPos({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        Geocode.fromLatLng(
          position.coords.latitude,
          position.coords.longitude
        ).then(
          (response) => {
            const address = response.results[0].formatted_address;
            setAddress(address);
          },
          (error) => {
            console.error(error);
          }
        );
      },
      (error) => {
        // See error code charts below.
        console.log(error.code, error.message);
      },
      { enableHighAccuracy: true, timeout: 60000, maximumAge: Infinity }
    );
  }, []);

  React.useEffect(() => {
    if (!img || img?.length === 0) {
      setShow(true);
    }
  }, [img]);

  return (
    <Page
      title={<img src={epod} alt="" height={25} />}
      backTo={() => History.goBack()}
      action={
        <div>
          <Button
            type="button"
            variant="success"
            className={cn(
              "pe-4 ps-4 rounded w-100 fs-7",
              StateForm?.loading ? "btn-loading" : ""
            )}
            onClick={$onStart}
          >
            Simpan
          </Button>
        </div>
      }
    >
      <div className="py-3">
        <div className="row align-items-center justify-content-center ">
          {img?.map((d, i) => (
            <div
              key={i}
              className="position-relative col-4"
              style={{ height: 100, width: 100, margin: 5 }}
            >
              <div
                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center bg-danger rounded-circle border border-2 border-white mt-n2 me-n1 rounded"
                style={{ height: 25, width: 25 }}
                onClick={() => $removeImg(i)}
              >
                <FaTimes color="#fff" />
              </div>
              <img
                src={d}
                alt=""
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "cover",
                  borderRadius: 5,
                }}
              />
            </div>
          ))}

          {StateForm?.loading ? (
            <div
              className="col-4 rounded bg-dark bg-opacity-25 d-flex flex-column align-items-center justify-content-center"
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <div className="spinner-border text-blue" role="status"></div>
              <div>
                <small>uploading</small>
              </div>
            </div>
          ) : null}

          <div
            className="col-4 d-flex flex-column align-items-center justify-content-center"
            onClick={() => setShow(true)}
          >
            <div
              className={cn(
                "border-dashed rounded  d-flex flex-column align-items-center justify-content-center",
                StateForm?.errors?.images ? "border-danger" : "border-primary"
              )}
              style={{ height: 100, width: 80, margin: 5 }}
            >
              <FaPlus
                size={20}
                color={StateForm?.errors?.images ? "red" : "#2f83ba"}
              />
              <div>
                <small>ambil foto</small>
              </div>
            </div>

            {StateForm?.errors?.images ? (
              <div
                className="text-center"
                style={{ marginBottom: 5, marginTop: 10 }}
              >
                <span style={{ color: "red" }}>
                  {StateForm?.errors?.images}
                </span>
              </div>
            ) : null}
          </div>
        </div>

        {StateForm?.errors?.id ? (
          <div
            className="text-center"
            style={{ marginBottom: 5, marginTop: 10 }}
          >
            <span style={{ color: "red" }}>{StateForm?.errors?.id}</span>
          </div>
        ) : null}
      </div>

      {type === "delivered" || type === "shipment-delivered" ? (
        <div className="py-3">
          <div>Diterima Oleh:</div>
          <div className="form-group mb-3">
            <Input
              icon={<FaUserAlt />}
              value={receiver}
              onChange={(e) => setReceiver(e.target.value)}
              type="text"
              placeholder="masukkan nama penerima"
              error={StateForm?.errors?.received_by}
              lg
            />
          </div>

          <div>
            <div>Keterangan:</div>
            <div className="form-group mb-3 ">
              <Input
                value={note}
                onChange={(e) => setNote(e.target.value)}
                type="text"
                placeholder="keterangan"
                lg
              />
            </div>
          </div>

          {sig ? (
            <div
              className="position-relative border border-primary rounded bg-white"
              style={{ height: 150, margin: 5 }}
            >
              <div
                className="position-absolute top-0 end-0 d-flex align-items-center justify-content-center bg-danger rounded-circle border border-2 border-white mt-n2 me-n1 rounded"
                style={{ height: 25, width: 25 }}
                onClick={() => setSig(null)}
              >
                <FaTimes color="#fff" />
              </div>
              <img
                src={sig?.image}
                alt=""
                style={{
                  height: "100%",
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: 5,
                }}
              />
            </div>
          ) : (
            <Popup
              modal
              trigger={
                <button className="btn btn-primary fs-7 w-100">
                  Ambil Tanda Tangan
                </button>
              }
              closeOnDocumentClick={false}
            >
              {(close) => (
                <SignatureSection
                  setSig={setSig}
                  onClose={close}
                  loading={StateForm?.loading}
                />
              )}
            </Popup>
          )}
        </div>
      ) : null}

      {(type === "disputed" || type === "shipment-disputed") && (
        <div className="px-2 py-3">
          <div>Alasan:</div>
          <div className="form-group mb-3 ">
            <Input
              value={note}
              onChange={(e) => setNote(e.target.value)}
              type="text"
              placeholder="masukkan alasan"
              error={StateForm?.errors?.disputed_note}
              lg
            />
          </div>
        </div>
      )}

      {type === "loading" ||
      (type === "delivered" && !is_receive && manifest_type === "last_mile") ? (
        <ShipmentList data={data} type={type} onChange={(e) => setJobs(e)} />
      ) : null}

      <Modal
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
        size="small"
        enforceFocus={true}
        fullscreen
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <CameraScreen
            setImg={setImage}
            numberImg={img?.length}
            onClose={() => setShow(false)}
            code={`${leg_type}-${leg_id}`}
            type={type}
          />
        </Modal.Body>
      </Modal>
    </Page>
  );
};

export default PODScreen;
